"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Switch = _interopRequireDefault(require("@material-ui/core/Switch"));
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const styles = props => ({
  root: {
    height: 22,
    marginTop: props.theme.spacing(1.7),
    padding: 0,
    width: 49
  },
  switchBase: {
    padding: 1,
    "&$checked": {
      color: props.theme.palette.common.white,
      transform: "translateX(26px)",
      "& + $track": {
        backgroundColor: props.variant,
        border: "none",
        opacity: 1
      }
    }
  },
  thumb: {
    width: 20,
    height: 20
  },
  track: {
    backgroundColor: "#ebebe8",
    borderRadius: 22 / 2,
    opacity: 1,
    transition: props.theme.transitions.create(["background-color", "border"])
  },
  checked: {}
});
const withStylesProps = styles => ParentCompontent => props => {
  const Component = (0, _styles.withStyles)(theme => styles({
    ...props,
    theme
  }))(ParentCompontent);
  return /*#__PURE__*/_react.default.createElement(Component, props);
};
var _default = exports.default = withStylesProps(styles)(props => /*#__PURE__*/_react.default.createElement(_Switch.default, _extends({
  classes: {
    root: props.classes.root,
    switchBase: props.classes.switchBase,
    thumb: props.classes.thumb,
    track: props.classes.track,
    checked: props.classes.checked
  }
}, props)));